import { CapacityTooltip } from "../features/capacity/CapacityTooltip";
import { useAccountCapacity } from "../features/capacity/AccountCapacityContext";

export function AccountCapacityWidget() {
  const { state } = useAccountCapacity();
  return (
    <section aria-label="Account capacity allocation" className="account-capacity">
      {state.status === "ready" ? (
        <>
          <progress
            aria-label="Allocated capacity"
            aria-valuetext={`${state.data.allocatedCapacity} allocated of ${state.data.totalCapacity} total capacity units`}
            max={Math.max(1, state.data.totalCapacity)}
            value={
              state.data.totalCapacity > 0
                ? Math.min(state.data.allocatedCapacity, state.data.totalCapacity)
                : state.data.allocatedCapacity > 0
                  ? 1
                  : 0
            }
          />
          <span className="form-note">
            Capacity: {state.data.allocatedCapacity} / {state.data.totalCapacity}{" "}
            <CapacityTooltip />
          </span>
        </>
      ) : (
        <span className="form-note" role="status">
          {state.status === "loading" ? "Loading capacity…" : "Capacity unavailable"}
        </span>
      )}
    </section>
  );
}
